import React, { useEffect, useState } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import { useLocation } from "react-router-dom";
export const GestionGerencial = () => {

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const modalValue = searchParams.get("modal");
  const [activate, setActivate] = useState(true);
  const [ruta, setRuta] = useState("");
  const actualizarRuta = () => {
    const op = require("../../../public/modulos/datos");
    const url = op.iframe;
    const token = sessionStorage.getItem("jwtToken");
    const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
   
    if (modalValue) {
      if (modalValue === "cliente") {
        setRuta(`${url}/cliente/${token}/${afiliado}`);
      } else if (modalValue === "vendedor") {
        setRuta(`${url}/vendedor/${token}/${afiliado}`);
      } else if (modalValue === "grafica") {
        setRuta(`${url}/graficos/${token}/${afiliado}`);
      } else if (modalValue === "mapaCliente") {
        setRuta(`${url}/mapaCliente/${token}/${afiliado}`);
      } else if (modalValue === "mapaAlmacen") {
        setRuta(`${url}/mapaAlmacen/${token}/${afiliado}`);
      }
    }
  };
  const handleIframeLoad = () => {
    setActivate(false);
  }
  useEffect(() => {
    setActivate(true);
    actualizarRuta();
  }, []);
  return (
    <div className="w-100 h-100">
      {ruta && ruta !== "" ? (
        <iframe
          src={ruta}
          width="100%"
          onLoad={handleIframeLoad}
          style={{ border: "1px solid #ccc", height: "calc(100vh - 98px)" }}
        />
      ) : (
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/gestionGerencial/index.js